
import Header from "../components/adminHeader.jsx";
import AdminSidebar from "../components/adminSidebar.jsx";
import AdminHome from "../components/adminHome.jsx";
import Footer from "../components/footer.jsx";

function AdminHomePage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <AdminSidebar /> 
      < AdminHome/> 
    </div>
    <Footer /> 
  </div>

  );
}
export default AdminHomePage;
